import { render } from "./DateTimeFormat.vue?vue&type=template&id=421bf81a&ts=true"
import script from "./DateTimeFormat.vue?vue&type=script&lang=ts"
export * from "./DateTimeFormat.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__